<template>
  <div class="full">
    <md-card>
      <md-card-header>
        <md-whiteframe md-tag="md-toolbar" md-elevation="2" class="md-medium">
          <div class="md-toolbar-container">
            <h2 class="md-title">Dashboard</h2>
          </div>
        </md-whiteframe>
      </md-card-header>
      
      <md-card-content class="scrolable">
        <md-layout :md-gutter="16">
          <md-layout md-flex="25">
            <md-card class="full-width card-spacing">
              <md-card-header>
                <md-card-header-text>
                  <h4>Chamados Abertos</h4>
                </md-card-header-text>
              </md-card-header>

              <md-card-content class="md-card-info-content">
                <span class="content-text">{{info.openTickets}}</span>
              </md-card-content>
            </md-card>
          </md-layout>

          <md-layout md-flex="25">
            <md-card class="full-width card-spacing">
              <md-card-header>
                <md-card-header-text>
                  <h4>Chamados Concluídos</h4>
                </md-card-header-text>
              </md-card-header>

              <md-card-content>
                <span class="content-text"> {{info.closedTickets}} </span>
              </md-card-content>
            </md-card>
          </md-layout>

          <md-layout md-flex="25">
            <md-card class="full-width card-spacing">
              <md-card-header>
                <md-card-header-text>
                  <h4>Tempo Médio de Chamados Abertos</h4>
                </md-card-header-text>
              </md-card-header>

              <md-card-content>
                <span class="content-text" v-if="info.meanOpenTime"> {{info.meanOpenTime}} dias </span>
              </md-card-content>
            </md-card>
          </md-layout>

          <md-layout md-flex="25">
            <md-card class="full-width card-spacing">
              <md-card-header>
                <md-card-header-text>
                  <h4>Tempo Médio de Resolução</h4>
                </md-card-header-text>
              </md-card-header>

              <md-card-content>
                <span class="content-text" v-if="info.meanResolutionTime"> {{info.meanResolutionTime}} dias </span>
              </md-card-content>
            </md-card>
          </md-layout>
        </md-layout>

        <md-layout :md-gutter="16" class="top-spacing">
          <md-layout md-flex="100">
            <md-card class="full">
              <md-card-content  class="md-card-graph-content">
                <BarChart :chart-data="organizationBarDatacollection" :options="organizationBarOpt" :width="800" :height="220"></BarChart>
              </md-card-content>
            </md-card>
          </md-layout>
        </md-layout>

        <md-layout :md-gutter="16" class="top-spacing">
          <md-layout>
            <md-card class="full">
              <md-card-content class="md-card-graph-content">
                <PieChart :chart-data="typePieDatacollection" :options="typePieOpt" :width="200" :height="200"></PieChart>
              </md-card-content>
            </md-card>
          </md-layout>
        </md-layout>
      </md-card-content>

    </md-card>
  </div>
</template>

<script>
  import ticketsService from '../services/TicketsService'
  import PieChart from './PieChart'
  import BarChart from './BarChart'
  import 'chartjs-plugin-datalabels'

  export default {
    data(){
      return{
        info: {
          openTickets : null,
          closedTickets : null,
          meanOpenTime : null,
          meanResolutionTime : null,
          openTicketsByOrganization : null,
          openTicketsByType : null
        },

        organizationBarOpt: {
          responsive: true,
          scales: {
            xAxes: [{
              barPercentage: 1.7
            }]
          },
          legend:{
            display: false,
            position: 'left'
          },
          title: {
            display: true,
            text: 'Chamados Abertos por Organização'
          }
        },
        organizationBarDatacollection: {
          datasets: null
        },

        typePieOpt: {
          responsive: true,
          maintainAspectRatio: false,
          legend:{
            display: true,
            position: 'left'
          },
          title: {
            display: true,
            text: 'Chamados Abertos por Tipo'
          }
        },
        typePieDatacollection: {
          datasets: null
        }
      }
    },

    components:{
      PieChart,
      BarChart
    },
    
    created(){
      ticketsService.findGeneralStatus().then((success) => {
        this.info = success.body;

        this.info.meanOpenTime = Math.round(this.info.meanOpenTime/24)
        this.info.meanResolutionTime = Math.round(this.info.meanResolutionTime/24)

        this.mountOrganizationBarChart(this.info);
        this.mountTypePieChart(this.info);
      });

    },

    methods: {
      mountOrganizationBarChart : function(info){
        var organizationTickets = Object.values(info.openTicketsByOrganization);
        var organizationLabels = Object.keys(info.openTicketsByOrganization);

        var colors = this.colorsByTicketCount(organizationTickets, 'rgba(26, 142, 35, {0})');

        this.organizationBarDatacollection = {
          labels: organizationLabels,
          datasets: [
            {
              label: '',
              backgroundColor: colors,
              data: Object.values(organizationTickets)
            }
          ]
        }
      },

      mountTypePieChart : function(info){
        var typeTickets = Object.values(info.openTicketsByType);
        var typeLabels = Object.keys(info.openTicketsByType);

        var colors = this.colorsByTicketCount(typeTickets, 'rgba(63, 63, 191, {0})');

        this.typePieDatacollection = {
          labels: typeLabels,
          datasets: [
            {
              label: '',
              backgroundColor: colors,
              data: Object.values(typeTickets),
              datalabels: {
                anchor: 'end'
              }
            }
          ]
        }
      },

      colorsByTicketCount : function(ticketCounts, colorTemplate){

        if (!String.prototype.format) {
          String.prototype.format = function() {
            var formatted = this;
            for (var i = 0; i < arguments.length; i++) {
              var regexp = new RegExp('\\{'+i+'\\}', 'gi');
              formatted = formatted.replace(regexp, arguments[i]);
            }
            return formatted;
          }
        };

        var colors = [];
        var max = Math.max.apply(null, ticketCounts);
        var min = Math.min.apply(null, ticketCounts);

        ticketCounts.forEach(count => {
          var colorValue = (count - min)/(max - min);
          colorValue += 0.2;
          colors.push(colorTemplate.format(colorValue));
        });
        return colors;
      }

      
    }

  }
</script>

<style>
  .scrolable{
    position: relative;
    max-height: 450px;
    overflow-y: scroll;
  }

  .full-width{
    width: 100% !important;
  }

  .top-spacing{
    margin-top: 10px;
  }

  .card-spacing{
    padding-left: 10px;
    padding-right: 10px;
    height: 120px;
  }

  .md-card-info-content{
    padding-bottom: 0px !important;
  }

  .md-card-graph-content{
    margin-top: 0px !important;
  }

  .content-text{
    font-size: 20px !important;
    color: teal;
  }
</style>



// WEBPACK FOOTER //
// src/components/TicketsDashboard.vue